/**
 * VelocityIcon — Mi6 custom glyph: stopwatch
 * viewBox 0 0 80 80, stroke 1.5px, currentColor
 */
export default function VelocityIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {/* Crown / top button */}
      <rect x="35" y="10" width="10" height="5" rx="2" stroke="currentColor" strokeWidth="1.5" />
      {/* Side button */}
      <line x1="60" y1="24" x2="64" y2="20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Main face */}
      <circle cx="40" cy="46" r="26" stroke="currentColor" strokeWidth="1.5" />
      {/* Stem from button to face */}
      <line x1="40" y1="15" x2="40" y2="20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Center pivot */}
      <circle cx="40" cy="46" r="2" fill="currentColor" />
      {/* Sweep hand — angled for motion */}
      <line x1="40" y1="46" x2="52" y2="32" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Minute tick marks */}
      <line x1="40" y1="22" x2="40" y2="26" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="40" y1="66" x2="40" y2="70" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="16" y1="46" x2="20" y2="46" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="60" y1="46" x2="64" y2="46" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
